import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
const useCompanyUsers = (queryOptions = {}) => {
  const companyId = useCompanyIdFromUrl();

  return useQuery({
    ...queryOptions,
    enabled: !!companyId && queryOptions?.enabled !== false,
    queryKey: ["companyUsers", companyId],
    queryFn: () => {
      return apiClient.get(`companies/${companyId}/users`, {
        params: { companyId },
      });
    },
  });
};

export { useCompanyUsers };
